const requestIdleCallbackPolyfill =
  typeof window.requestIdleCallback === 'function'
    ? window.requestIdleCallback.bind(window)
    : (callback) => setTimeout(callback, 1);

function runWhenIdle(callback, options) {
  requestIdleCallbackPolyfill(callback, options);
}

function isLowPowerDevice() {
  return (
    (navigator.hardwareConcurrency ?? 8) <= 2 ||
    (navigator.deviceMemory ?? 8) <= 2
  );
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function shouldSkipHeavyAnimation() {
  return prefersReducedMotion() || isLowPowerDevice();
}
